import { mergeAttributes } from '@tiptap/core';
import Highlight from '@tiptap/extension-highlight';

/**
 * Change the tag from <mark> to <span> and use just the background-color style.
 */
export default Highlight.extend({
  //this extension must be parsed before textStyle
  priority: 102,

  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: element => element.style.backgroundColor,
        renderHTML: attributes => {
          if (!attributes.color) {
            return {};
          }

          return {
            style: `background-color: ${attributes.color}`,
          };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, any> }) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  parseHTML() {
    return [
      {
        tag: 'span[style*="background-color"]',
      },
    ];
  },
});
